import React from 'react';

const Example = class Example extends React.Component {
  componentDidMount() {
    const { parent, nextStep } = this.props;

    parent.setState({
      next: nextStep
    });
  }

  componentDidUpdate() {
    const { parent, nextStep, statusClass } = this.props;

    if(statusClass === 'slide-active' && parent.state.next !== nextStep) {
      parent.setState({
        next: nextStep
      });
    }
  }

  render() {
    const { statusClass } = this.props;
    const translation = this.props.translation.example;

    return (
      <main className={`panel panel--medium ${statusClass}`} aria-labelledby="step3">
        <h2 className="panel__title panel__title--alt" id="step3">
          {translation.heading}
        </h2>

        <p>{translation.body}</p>

        {statusClass === 'slide-active' &&
          <div className="vid__wrap vid__wrap--wide">
            <iframe
              className="vid__video"
              src="https://player.vimeo.com/video/404603947?byline=0&portrait=0&autoplay=1"
              width="640"
              height="455"
              frameBorder="0"
              allow="autoplay; fullscreen"
              allowFullScreen
            />
          </div>
        }
      </main>
    )
  }
}

export default Example;



// WEBPACK FOOTER //
// ./src/app/components/SessionStart/Example.js